import { queryOptions, useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import {
	getApiUrl,
	getChatsAttachmentsIdV2Path,
} from "web_myplann/Infrastructure/Api/Api";
import {
	type SessionState,
	sessionState,
} from "web_myplann/Shared/State/sessionAtom";
import { fetchAuthorized } from "web_myplann/Shared/Utils/fetchAuthorized";

const ATTACHMENT_GC_TIME = 10 * 60 * 1000;
const UNKNOWN_ATTACHMENT_ID = -1;

export const chatAttachmentQueryOptions = (
	attachmentId: number,
	session: SessionState,
) =>
	queryOptions({
		queryKey: ChatKeys.attachment(attachmentId),
		queryFn: async () => {
			const response = await fetchAuthorized({
				url: `${getApiUrl()}${getChatsAttachmentsIdV2Path(attachmentId)}`,
				credentials: session,
				errorMessage: `Chat attachment ${attachmentId} could not be loaded`,
				skipToast: true,
				queryKey: ChatKeys.attachment(attachmentId),
			});

			return response.blob();
		},
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: ATTACHMENT_GC_TIME,
		meta: { persist: false },
	});

export const useChatAttachmentQuery = (
	attachmentId: number | undefined,
	enabled: boolean,
) => {
	const session = useAtomValue(sessionState);

	return useQuery({
		...chatAttachmentQueryOptions(
			attachmentId ?? UNKNOWN_ATTACHMENT_ID,
			session,
		),
		enabled: enabled && attachmentId !== undefined,
	});
};
